import { render, staticRenderFns } from "./MorningstarAward.vue?vue&type=template&id=8b43e4d2&scoped=true&"
import script from "./MorningstarAward.vue?vue&type=script&lang=js&"
export * from "./MorningstarAward.vue?vue&type=script&lang=js&"
import style0 from "./MorningstarAward.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MorningstarAward.vue?vue&type=style&index=1&id=8b43e4d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b43e4d2",
  null
  
)

component.options.__file = "packages/cb-components-morningstar-award/src/components/MorningstarAward/MorningstarAward.vue"
export default component.exports